<template>
  <div id="components-layout-demo-basic">
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
      <defs>
        <symbol id="icon-search" viewBox="0 0 427.83 427.94">
          <g id="layer1">
            <path id="circle2017"
              d="M192,0C86.17,0,0,86.17,0,192S86.13,384.13,192,384.13A190.78,190.78,0,0,0,311.58,342l80,79.92a21.38,21.38,0,0,0,30.25-30.21l-80-80A191.16,191.16,0,0,0,384,191.92c0-105.79-86.21-192-192-192Zm0,42.67A149.38,149.38,0,1,1,42.66,192.13q0-.08,0-.17A148.94,148.94,0,0,1,191.25,42.67Z"
              transform="translate(0.04 0.08)" />
          </g>
        </symbol>
        <symbol id="icon-delete" viewBox="0 0 24 24">
          <g id="Layer_2" data-name="Layer 2">
            <path
              d="m12 1a11 11 0 1 0 11 11 11.013 11.013 0 0 0 -11-11zm4.242 13.829a1 1 0 1 1 -1.414 1.414l-2.828-2.829-2.828 2.829a1 1 0 0 1 -1.414-1.414l2.828-2.829-2.828-2.829a1 1 0 1 1 1.414-1.414l2.828 2.829 2.828-2.829a1 1 0 1 1 1.414 1.414l-2.828 2.829z" />
          </g>
        </symbol>
        <symbol id="icon-edit" viewBox="0 0 512.009 512.00">
          <g>
            <g>
              <path
                d="M397.96,330.099c-13.755,0-24.872,11.118-24.872,24.872v78.125c0,13.73-11.143,24.872-24.872,24.872H74.617c-13.73,0-24.872-11.143-24.872-24.872V109.754c0-13.73,11.143-24.872,24.872-24.872h144.509c13.754,0,24.872-11.118,24.872-24.872c0-13.754-11.118-24.872-24.872-24.872H74.617C33.478,35.136,0,68.615,0,109.754v323.342c0,41.139,33.478,74.617,74.617,74.617h273.597c41.139,0,74.617-33.453,74.617-74.617v-78.124C422.832,341.217,411.714,330.099,397.96,330.099z" />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M484.193,31.977c-18.057-18.057-41.637-27.161-65.39-27.658c-24.997-0.547-50.143,8.506-69.046,27.434L181.37,200.14c-24.574,24.674-38.105,57.406-38.105,92.177v55.714c0,13.754,11.118,24.872,24.872,24.872h55.714c34.772,0,67.504-13.531,92.202-38.13l168.163-168.163C521.277,129.527,521.277,69.087,484.193,31.977z M280.91,299.581c-15.247,15.197-35.543,23.579-57.057,23.579H193.01v-30.842c0-21.515,8.382-41.811,23.554-57.033l111.006-111.006l64.32,64.32L280.91,299.581z M449.023,131.467L427.06,153.43l-64.32-64.32l21.962-21.962c17.759-17.759,46.611-17.709,64.32,0C466.732,84.881,466.732,113.733,449.023,131.467z" />
            </g>
          </g>
        </symbol>
      </defs>
    </svg>
    <a-layout>
      <!--   头部   -->
      <a-layout-header style="border-bottom:1px solid #eeeeee;margin-top:10px;">
        <div class="container clearfix" style="position: relative;">
          <!--   Logo   -->
          <router-link tag="a" to="/">
            <div class="logo" style="display: inline-block;height:55px;width:200px;float:left;padding-top:3px;">
              <img src="@/assets/Icons/SnippetsIcon.svg" alt="logo" style="width:38px;height:38px;vertical-align:top;">
              <span style="">Diggo Snippets</span>
            </div>
          </router-link>
          <!--   搜索框   -->
          <div style="float:left;margin-left:131px;height:40px;position:relative;">
            <a-auto-complete v-model="searchName" style="float:left;width:365px;" placeholder="Search Name"
              spellcheck="false" @select="onNameSelect" @change="onNameChange">
              <template slot="dataSource">
                <a-select-option v-for="item in searchList" :key="item.employee_id"
                  :value="`${item.employee_id},${item.nickname},${item.username}`">
                  <img v-if="item.profile_picture" :src="item.profile_picture" alt=""
                    style="width:40px;height:40px;border-radius:50%;">
                  <img v-else src="@/assets/Images/defaultavatar.jpeg" alt=""
                    style="width:40px;height:40px;border-radius:50%;">
                  <span style="margin-left:12px;">{{ item.nickname }}</span>
                </a-select-option>
              </template>
              <a-input>
              </a-input>
            </a-auto-complete>
            <svg width="16" height="16" style="position:absolute;right:14px;top:12px;z-index:99;cursor:pointer;">
              <use xlink:href="#icon-search"></use>
            </svg>
          </div>
          <!-- <a-auto-complete
            v-model="searchName"
            style="float:left;width:365px;margin-left:131px;"
            placeholder="Search Name"
            spellcheck="false"
            @select="onNameSelect"
            @change="onNameChange">
            <template slot="dataSource">
              <a-select-option v-for="item in searchList" :key="item.employee_id"
                               :value="`${item.employee_id},${item.nickname},${item.username}`">
                <img v-if="item.profile_picture" :src="item.profile_picture" alt=""
                     style="width:40px;height:40px;border-radius:50%;">
                <img v-else src="@/assets/Images/defaultavatar.jpeg" alt=""
                     style="width:40px;height:40px;border-radius:50%;">
                <span style="margin-left:12px;">{{ item.nickname }}</span>
              </a-select-option>
            </template>
            <a-input>
              <a-icon slot="suffix" type="search" class="certain-category-icon" />
            </a-input>
          </a-auto-complete> -->
          <div style="width:40px;height:40px;float: right;border-radius: 50%;cursor: pointer" @click="backToReport">
            <img :src="avatar" alt="" style="width:100%;height:100%;border-radius: 50%;margin-bottom:26px;">
          </div>
          <!--   个人日期选择   -->
          <a-range-picker v-show="snippetsDatePicker" :format="dateFormat"
            :value="[moment(reportStartDate), moment(reportEndDate)]" :allowClear=false
            style="float:right;width:300px;margin-right:24px;" @change="onDateRangeChange" />
          <!--   团队日期选择   -->
          <img src="@/assets/Icons/time.svg" alt=""
            style="float:right;width: 16px;height: 16px;position:absolute;right:84px;top:11px;z-index:99">
          <a-date-picker v-show="teamDatePicker" :format="dateFormat" :value="moment(reportDate)"
            placeholder="Select Date" :allowClear=false style="float:right;width:160px;margin-right:24px;"
            @change="onDateChange" />
        </div>
      </a-layout-header>
      <!--   内容   -->
      <a-layout-content>
        <!--   信息页   -->
        <div class="container">
          <div class="report">
            <div id="report-menu" class="report-menu">
              <div class="info-prof" style="display: flex">
                <div class="info-prof-avatar">
                  <img v-if="searchAvatar" :src="workList.employee_info.profile_picture" alt="">
                  <img v-if="groupAvatar"
                    :src="'https://corp.impr-inc.com/group_avatar/' + groupWorkList.group_info.group_avatar" alt="">
                  <img v-if="!searchAvatar && !groupAvatar" src="@/assets/Images/defaultavatar.jpeg" alt="">
                </div>
                <div style="margin-left:12px;display:flex;flex-direction:column">
                  <div v-if="workList && workList.employee_info" class="info-prof-name">{{
                    workList.employee_info.nickname }}
                  </div>
                  <div v-if="groupWorkList && groupWorkList.group_info" class="info-prof-name">{{
                    groupWorkList.group_info.group_name }}</div>
                  <div v-if="workList && workList.employee_info" class="info-prof-offer">{{
                    workList.employee_info.job_title
                    }}</div>
                  <div v-if="groupWorkList && groupWorkList.group_info" class="info-prof-offer">{{
                    groupWorkList.group_info.group_email }}</div>
                </div>
              </div>
              <!--   切换   -->
              <div class="tab" style="margin-top:28px;">
                <a-menu mode="inline" style="width: 280px;border:0;" :open-keys="openKeys" :default-open-keys="['0']"
                  @click="handleClick" @openChange="onOpenChange">
                  <a-sub-menu key="0" id="first-sub-menu" class="first-sub-menu" @titleClick="snippetsChange('0')">
                    <span slot="title">
                      <img ref="myIcon" src="@/assets/Icons/Snippets.svg" alt="" style="width:24px;height:24px;"
                        class="none">
                      <img ref="myIconBlue" src="@/assets/Icons/Snippets-blue.svg" alt=""
                        style="width:24px;height:24px;">
                      <span class="sub-menu-title">My Snippets</span>
                    </span>
                  </a-sub-menu>
                  <template v-for="(item, index) in groupList">
                    <a-sub-menu :key="item.group_id" v-if="item.group_id != '8'"
                      @titleClick="groupChange(index, item.group_id, item.group_name)">
                      <span slot="title">
                        <img :ref="`teamIcon`" src="@/assets/Icons/team.svg" alt="" style="width:24px;height:24px;">
                        <img :ref="`teamIconBlue`" src="@/assets/Icons/team-blue.svg" alt=""
                          style="width:24px;height:24px;" class="none">
                        <span class="sub-menu-title">{{ item.group_name }}</span>
                      </span>
                      <a-menu-item v-for="single in item.members" :key="single.employee_id" class="menu-item-user"
                        @click="urlNamePathLink(single.username)">
                        <span>{{ single.nickname }}</span>
                      </a-menu-item>
                    </a-sub-menu>
                  </template>

                </a-menu>
              </div>
            </div>
            <div class="report-content">
              <div v-if="contentVisible">
                <a-spin :spinning="snippetsSpinning" class="report-mysnippets">
                  <div v-show="workReportEdit" class="timeline-item-first-wrap">
                    <div style="display:flex;justify-content:space-between">
                      <div style="width:142px;position: relative">
                        <a-date-picker :format="dateFormat" :value="moment(workDateSelect)" placeholder="Select Date"
                          :allowClear=false class="reportDateSelect" :disabled="!workEditStatus"
                          @change="onWorkDateChange" />
                        <img src="@/assets/Icons/time-blue.svg" alt=""
                          style="width: 16px;height: 16px;position:absolute;left:120px;top:12px;">
                      </div>
                      <a-input placeholder="Project" v-model="workTitle"
                        style="width:580px;height:40px;border-radius: 8px;border: solid 1px #e5e5e5;background-color:#ffffff;"></a-input>
                    </div>
                    <!-- <a-textarea
                      placeholder="Please enter the content of the project"
                      v-model="workContent"
                      class="timeline-textarea"
                      onresize="false"
                      style="white-space:pre;"
                    /> -->
                    <!-- 富文本 -->
                    <quill-editor ref="myQuillEditor" class="timeline-textarea" v-model="workContent"
                      :options="editorOptions">
                    </quill-editor>
                    <div class="quill-tip">为选中内容应用样式/添加超链接</div>
                    <div style="display:flex;justify-content:space-between;">
                      <a-select placeholder="Process" v-model="workProcess" class="process-select"
                        @change="processChange">
                        <a-select-option v-for="(item, index) in processData" :key="index" :value="item">{{ item
                          }}</a-select-option>
                      </a-select>
                      <!-- <span>选中目标nei rong添加链接</span> -->
                      <a-button class="timeline-submit" @click="snippetsSubmit()">{{ workEditText }}</a-button>
                    </div>
                  </div>
                  <a-timeline>
                    <a-timeline-item ref="reportTimeLine" v-for="(item, index) in workList.record_list" :key="index">
                      <div style="display: flex;justify-content: space-between;margin-right: 9px;">
                        <div class="timeline-time"
                          :style="{ color: item.addtime == todayDate ? '#2177e9' : '#222222' }">
                          {{ moment(item.addtime).format('MM-DD-YYYY') }}
                          <span>{{ moment(item.addtime).format('dddd') }}</span>
                        </div>
                      </div>
                      <div class="timeline-textarea-history" :value="item.list" style="padding-top:9px;">
                        <div>
                          <img v-show="item.list.length == '0'" src="@/assets/Images/none.png" alt=""
                            style="width: 48px;height: 48px;opacity: 0.5;margin-top:32px;margin-left:360px;">
                          <div v-show="item.list.length == '0'"
                            style="margin-left: 304px;margin-top:14px;font-family: GoogleSans-Regular;font-size: 14px;color: #bbbbbb;opacity: 0.5;">
                            Work Report Not Entered</div>
                        </div>
                        <div>
                          <div v-for="(single, index) in item.list" :key="index" class="report-wrap">
                            <span class="record-title">{{ single.record_project }}</span>
                            <span class="record-content"
                              style="word-break:normal;white-space:pre-wrap;word-wrap : break-word ;"
                              v-html="single.record_content"></span>
                            <span class="record-process">{{ single.record_process }}%</span>
                            <a-popconfirm v-show="workReportEdit" title="确定删除该条工作记录吗？" ok-text="确定" cancel-text="取消"
                              @confirm="reportDeleteConfirm(single.id)" @cancel="reportDeleteCancel">
                              <span class="delete-icon"><svg width="20" height="20" fill="#dddddd">
                                  <use xlink:href="#icon-delete"></use>
                                </svg></span>
                            </a-popconfirm>
                            <span v-show="workReportEdit" class="edit-icon"
                              @click="changeReport(single.id, single.addtime, single.record_project, single.record_content, single.record_process)">
                              <svg width="20" height="20" fill="#dddddd">
                                <use xlink:href="#icon-edit"></use>
                              </svg>
                            </span>
                          </div>
                        </div>
                      </div>
                    </a-timeline-item>
                  </a-timeline>
                </a-spin>
              </div>
              <div v-else>
                <a-spin :spinning="teamSpinning" class="report-myteam">
                  <div class="group-title"><span>{{ groupName }}</span> Work Record On {{
                    moment(reportDate).format('MMM')
                    }}{{ moment(reportDate).format('-DD-YYYY') }}</div>
                  <a-button v-show="this.emailButtonStatus" type="primary"
                    @click="sendEmail(groupWorkList.group_info.group_email)"
                    style="position:absolute;right:0;">发送邮件</a-button>
                  <a-timeline class=group-timeline>
                    <a-timeline-item v-for="(item, index) in groupWorkList.userlist" :key="index">
                      <div style="display: flex;justify-content: space-between;margin-right: 9px;">
                        <div class="timeline-time" style="cursor: pointer;"
                          @click="urlNamePathLinkClose(item.username)">
                          <span>{{ item.nickname }}</span> <span style="color: #e6666c;">{{ item.job_title }}</span>
                        </div>
                      </div>
                      <div class="timeline-textarea-history" :value="item.record" style="padding-top:9px;">
                        <div>
                          <img v-show="item.record == ''" src="@/assets/Images/none.png" alt=""
                            style="width: 48px;height: 48px;opacity: 0.5;margin-top:32px;margin-left:360px;">
                          <div v-show="item.record == ''"
                            style="margin-left: 304px;margin-top:14px;font-family: GoogleSans-Regular;font-size: 14px;color: #bbbbbb;opacity: 0.5;">
                            Work Report Not Entered</div>
                        </div>
                        <div>
                          <div v-for="(single, index) in item.record" :key="index" class="report-wrap">
                            <span class="record-title">{{ single.record_project }}</span>
                            <span class="record-content"
                              style="word-break:normal;white-space:pre-wrap;word-wrap:break-word ;"
                              v-html="single.record_content"></span>
                            <span class="record-process">{{ single.record_process }}%</span>
                            <a-popconfirm v-show="workReportEdit" title="确定删除该条工作记录吗?" ok-text="确认" cancel-text="取消"
                              @confirm="reportDeleteConfirm(single.id)" @cancel="reportDeleteCancel">
                              <span class="delete-icon"><svg width="20" height="20" fill="#dddddd">
                                  <use xlink:href="#icon-delete"></use>
                                </svg></span>
                            </a-popconfirm>
                            <span v-show="workReportEdit" class="edit-icon"
                              @click="changeReport(single.id, item.date, single.title, single.item_content, single.process)">
                              <svg width="20" height="20" fill="#dddddd">
                                <use xlink:href="#icon-edit"></use>
                              </svg>
                            </span>
                          </div>
                        </div>
                      </div>
                    </a-timeline-item>
                  </a-timeline>
                </a-spin>
              </div>
            </div>
          </div>
        </div>
      </a-layout-content>
    </a-layout>
    <Bug></Bug>
  </div>
</template>

<script>
import moment from 'moment'
import api from '@/common/api.js'
import Bug from '../../components/Bug.vue'

moment.suppressDeprecationWarnings = true

export default {
  name: 'Report',
  components: {
    Bug,
  },
  inject: ['reload'],
  data() {
    return {

      moment,                                                           //  日期
      dateFormat: 'MM-DD-YYYY',                                         //  日期格式
      todayDate: moment()                                               //  今天日期
        .format()
        .slice(0, 10),
      searchName: '',                                                   //  搜索人名
      searchList: [],                                                   //  搜索下拉框
      processData: [],                                                  //  进度值
      userList: '',                                                     //  员工列表
      groupList: [],                                                    //  所有组信息
      workList: '',                                                     //  个人工作报告列表
      groupWorkList: '',                                                //  团队工作报告列表
      curUserId: '',                                                    //  当前员工编号
      groupId: '2',                                                     //  当前组别编号
      groupName: '',                                                    //  当前组别名称
      avatar: '',                                                       //  当前员工头像
      searchAvatar: '',                                                 //  搜索员工头像
      searchUserId: '',                                                 //  查找员工编号
      groupAvatar: false,                                               //  分组头像
      //  图标颜色切换 tab切换
      current: '0',
      rootSubmenuKeys: ['0', '1', '2', '3', '4', '5', '6', '7'],        //  所有tab页
      openKeys: ['0'],                                                  //  打开tab页
      contentVisible: true,                                             //  是否展示报告内容
      snippetsSpinning: false,                                          //  snippets内容加载状态
      teamSpinning: false,                                              //  team内容加载状态
      indexMark: '-1',                                                  //  默认tab标记
      //  日期切换
      snippetsDatePicker: true,                                         //  我的工作记录日期选择框
      teamDatePicker: false,                                            //  团队工作记录日期选择框
      workDateSelect: '',                                               //  我的工作记录日期
      reportDate: '',                                                   //  团队时间
      reportStartDate: '',                                              //  开始时间
      reportEndDate: '',                                                //  结束时间
      reportStatus: '',                                                 //  报告状态
      //  工作报告内容
      workId: '',                                                       //  工作报告id
      workDate: '',                                                     //  工作报告日期
      workTitle: '',                                                    //  工作报告标题
      workContent: '',                                                  //  工作报告内容
      workProcess: '100%',                                              //  工作报告进度
      workEditStatus: true,                                             //  添加/修改状态
      emailButtonStatus: '',                                             //  邮件发送按钮
      groupStatus: false,

      editorOptions: {
        placeholder: 'Please enter the content of the project',
        theme: 'snow',
        formats: [
          'header', 'bold', 'italic', 'underline', 'link', 'list'
        ],
        modules: {
          toolbar: [
            // [{ header: [1, 2, false] }],
            ['bold', 'italic', 'underline', 'link', { list: 'bullet' }, { list: 'ordered' }],
          ],
        }
      }

    }
  },
  computed: {
    //  工作报告输入框
    workReportEdit: function () {
      return this.curUserId === this.searchUserId
    },
    //  提交按钮文本
    workEditText: function () {
      return this.workEditStatus == true ? '+ Add a Snippet' : 'Save Changes'
    },
  },
  watch: {
    '$route'() {
      if (this.$route.params.name == undefined) {
        this.searchUserId = this.curUserId
        this.getUserWorkReport(this.searchUserId)
      } else if (this.$route.params.name !== undefined && this.$route.params.name.indexOf('group') == -1) {
        this.userList.filter(item => {
          if (this.$route.params.name == item.username) {
            this.searchUserId = item.employee_id
            this.getUserWorkReport(this.searchUserId)
          }
        })
      } else if (this.$route.params.name !== undefined && this.$route.params.name.indexOf('group') != -1) {
        this.groupList.filter(item => {
          const $name = this.$route.params.name.split('group')[1]
          if ($name == item.group_name.split(' ')[1]) {
            this.groupId = item.group_id
            this.groupName = item.group_name
            this.getGroupWorkReport()
          }
        })
      } else {
        this.searchUserId = this.curUserId
        this.getUserWorkReport(this.searchUserId)
      }
      this.initPage()
    }
  },
  methods: {
    // 路由 - 初始化页面
    initPage() {
    },
    //  tab切换
    handleClick(e) {
      this.current = e.key
    },
    //  自动闭合
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1)
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : []
      }
    },
    //  输入框内容改变 过滤名单
    onNameChange(name) {
      if (name == '') {
        this.searchList = []
      } else {
        this.searchList = this.userList.filter(item => {
          return item.username.indexOf(name.toLowerCase()) != -1 || item.legal_name.indexOf(name) != -1
        })
      }
    },
    //  选择后查询更改查询id 发起请求
    onNameSelect(info) {
      this.searchUserId = info.split(',')[0]
      this.searchName = info.split(',')[1]
      //  发起请求
      this.urlNamePathLinkClose(info.split(',')[2])
      this.onOpenChange(['-1'])
    },
    //  获取团队列表
    getGroupList() {
      this.$post(api.tool.getAllGroup, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
      }).then((res) => {
        if (res.code === 200) {
          this.groupList = res.list
          if (this.$route.params.name !== undefined && this.$route.params.name.indexOf('group') != -1) {
            const $name = this.$route.params.name.split('group')[1]
            this.groupList.filter(item => {
              if ($name == item.group_name.split(' ')[1]) {
                this.groupId = item.group_id
                this.groupName = item.group_name
                this.getGroupWorkReport()
                this.closeChange(true)
                this.groupStatus = true;
              }
            })
          }

          // if(this.$route.query.username == undefined && this.$route.query.group !== undefined) {
          //   this.groupList.filter(item => {
          //     if(this.$route.query.group == item.group_name.split(' ')[1]) {
          //       this.groupId = item.group_id
          //       this.groupName = item.group_name
          //       this.getGroupWorkReport()
          //       this.closeChange(true)
          //       this.groupStatus = true;
          //     }
          //   })
          // }
        }
      })
    },
    //  获取员工列表
    getUserList() {
      this.$post(api.tool.getUserList, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
      }).then((res) => {
        if (res.code === 200) {
          this.userList = res.list
          if (this.$route.params.name == undefined) {
            this.searchUserId = this.curUserId
            this.getUserWorkReport(this.searchUserId)
          } else if (this.$route.params.name !== undefined && this.$route.params.name.indexOf('group') == -1) {
            this.userList.filter(item => {
              if (this.$route.params.name == item.username) {
                this.searchUserId = item.employee_id
                this.getUserWorkReport(this.searchUserId)
                this.closeChange(true)
              }
            })
          }
          // if(this.$route.query.username == undefined && this.$route.query.group == undefined) {
          //   this.searchUserId = this.curUserId
          //   this.getUserWorkReport(this.searchUserId)
          // }else if(this.$route.query.username !== undefined && this.$route.query.group == undefined){
          //   this.userList.filter(item => {
          //     if(this.$route.query.username == item.username) {
          //       this.searchUserId = item.employee_id
          //       this.getUserWorkReport(this.searchUserId)
          //       this.closeChange(true)
          //     }
          //   })
          // }
        }
      })
    },
    //  个人切换
    snippetsChange(index) {
      //  图标切换
      const iconIndexArr = [0, 1, 2, 3, 4, 5, 6]
      iconIndexArr.forEach(item => {
        this.$refs.teamIcon[item].style.display = 'inherit'
        this.$refs.teamIconBlue[item].style.display = 'none'
      })
      if (index == 0) {
        this.$router.push({ path: '/snippets/' })
        if (this.indexMark != -1) {
          this.dateInit()
          this.$refs.myIcon.style.display = 'none'
          this.$refs.myIconBlue.style.display = 'inherit'
          this.indexMark = -1
          this.getUserWorkReport(this.curUserId)
        } else if (this.indexMark == -1) {
          this.$refs.myIcon.style.display = 'inherit'
          this.$refs.myIconBlue.style.display = 'none'
          this.indexMark = -2
        }
      }
    },
    //  分组切换
    groupChange(index, groupId, groupName) {
      this.groupId = groupId
      this.groupName = groupName
      this.urlGroupPathLinkClose(this.groupName.split(" ")[1])

      //  图标切换
      this.$refs.myIcon.style.display = 'inherit'
      this.$refs.myIconBlue.style.display = 'none'

      const iconIndexArr = [0, 1, 2, 3, 4, 5, 6]
      iconIndexArr.forEach(item => {
        if (item == index) {
          if (this.indexMark != index) {
            this.dateInit()
            this.$refs.teamIcon[item].style.display = 'none'
            this.$refs.teamIconBlue[item].style.display = 'inherit'
            this.indexMark = item
            this.getGroupWorkReport()
            //  获取报告
          } else if (this.indexMark == index) {
            this.$refs.teamIcon[item].style.display = 'inherit'
            this.$refs.teamIconBlue[item].style.display = 'none'
            this.indexMark = -2
          }
          // this.$refs.teamIcon[item].style.display = 'none'
          // this.$refs.teamIconBlue[item].style.display = 'inherit'
        } else {
          this.$refs.teamIcon[item].style.display = 'inherit'
          this.$refs.teamIconBlue[item].style.display = 'none'
        }
      })
    },

    //  获取员工工作报告
    getUserWorkReport(id) {
      // this.dateInit()
      this.searchUserId = id
      this.snippetsDatePicker = true
      this.teamDatePicker = false
      this.contentVisible = true
      this.groupAvatar = false
      //  发送请求
      this.snippetsSpinning = true
      // console.log('员工id:' + this.searchUserId, '报告日期范围:' + this.reportStartDate, this.reportEndDate, '员工报告获取')
      this.$post(api.tool.getWorkRecord, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        s_date: this.reportStartDate,
        e_date: this.reportEndDate,
        ee_id: this.searchUserId
      }).then((res) => {
        if (res.code === 200) {
          this.workList = res.list
          this.groupWorkList = ''

          if (this.workList.employee_info != null && this.workList.employee_info.profile_picture != '' && this.workList.employee_info.profile_picture != null) {
            this.searchAvatar = true
          } else {
            this.searchAvatar = false
          }
          this.snippetsSpinning = false
        }
      })
    },
    //  获取组工作报告
    getGroupWorkReport() {
      this.snippetsDatePicker = false
      this.teamDatePicker = true
      this.contentVisible = false
      this.searchAvatar = false
      this.searchUserId = -1
      //发送请求
      this.teamSpinning = true
      // console.log('组id:' + this.groupId, '组名称:' + this.groupName, '报告日期:' + this.reportDate, '团队报告获取')
      this.$post(api.tool.getGroupRecord, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        group_id: this.groupId,
        addtime: this.reportDate
      }).then((res) => {
        if (res.code === 200) {
          this.workList = ''
          this.groupWorkList = res.list
          this.emailButtonStatus = this.groupWorkList.group_info.email_settings == '1' ? true : false
          if (this.groupWorkList.group_info.group_avatar != '' && this.groupWorkList.group_info.group_avatar != null) {
            this.groupAvatar = true
          } else {
            this.groupAvatar = false
          }
          this.teamSpinning = false
        }
      })
    },
    //  修改个人报告日期
    onWorkDateChange(date) {
      this.workDateSelect = date.format('YYYY-MM-DD')
    },
    //  个人日期变动后页面跳转
    onDateRangeChange(data, dateString) {
      this.reportStartDate = moment(dateString[0]).format('YYYY-MM-DD')
      this.reportEndDate = moment(dateString[1]).format('YYYY-MM-DD')
      //  发送请求
      this.snippetsSpinning = true
      // console.log('员工id:' + this.searchUserId, '报告日期范围:' + this.reportStartDate, this.reportEndDate, '员工报告获取，时间改变')
      this.$post(api.tool.getWorkRecord, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        s_date: this.reportStartDate,
        e_date: this.reportEndDate,
        ee_id: this.searchUserId
      }).then((res) => {
        if (res.code === 200) {
          this.workList = res.list
          this.snippetsSpinning = false
        }
      })

    },
    //  团队日期变动后页面跳转
    onDateChange(date) {
      this.reportDate = date.format('YYYY-MM-DD')
      //  发送请求
      this.teamSpinning = true
      // console.log('组id:' + this.groupId, '组名称:' + this.groupName, '报告日期:' + this.reportDate, '团队报告获取,时间改变')
      this.$post(api.tool.getGroupRecord, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        group_id: this.groupId,
        addtime: this.reportDate
      }).then((res) => {
        if (res.code === 200) {
          this.groupWorkList = res.list
          this.teamSpinning = false
        }
      })
    },
    //  日期初始化
    dateInit() {
      this.reportDate = this.todayDate
      this.workDateSelect = this.todayDate
      this.reportStartDate = moment().subtract(6, 'days').format('YYYY-MM-DD')
      this.reportEndDate = this.todayDate
    },
    //  工作进度初始化
    processInit() {
      for (let i = 10; i >= 0; i--) {
        this.processData.push(i * 10 + '%')
      }
    },
    //  工作进度选择
    processChange(value) {
      this.workProcess = value
    },
    //  提交工作记录
    snippetsSubmit() {
      if (this.workEditStatus) {
        this.workId = ''
        this.workDate = this.workDateSelect
      }
      if (this.workContent == '') {
        this.$message.error('内容不能为空')
        return
      }
      //  发送请求
      // console.log(this.curUserId, this.workDate, '工作报告ID:' + this.workId, this.workTitle, this.workContent, this.workProcess, '提交/修改工作记录')
      this.$post(api.tool.dealWorkRecord, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        record_project: this.workTitle,
        record_content: this.workContent.replace(/<p>/g, "<p style='margin-top:0;margin-bottom:0'>").replace(/<ol>/g, "<ol style='padding-left: 20px;margin-top:0;margin-bottom:0'>").replace(/<ul>/g, "<ul style='padding-left: 20px;margin-top:0;margin-bottom:0'>").replace(/<li>/g, "<li style='padding-left: 2px;'>"),
        record_process: this.workProcess.split('%')[0],
        addtime: this.workDate,
        id: this.workId
      }).then((res) => {
        if (res.code === 200) {
          this.getUserWorkReport(this.curUserId)
          if (this.workEditStatus) {
            this.$message.success('添加成功')
            this.workId = ''
            this.workDate = ''
            this.workTitle = ''
            this.workContent = ''
            this.workProcess = '100%'
          } else {
            this.$message.success('修改成功')
            this.workEditStatus = true
            this.workId = ''
            this.workDate = ''
            this.workTitle = ''
            this.workContent = ''
            this.workProcess = '100%'
          }
        }
      })

    },
    //  修改工作记录
    changeReport(id, date, title, content, process) {
      this.workEditStatus = false
      this.workId = id
      this.workDate = date
      this.workDateSelect = date
      this.workTitle = title
      this.workContent = content.replace(/<br>/g, '\n')
      this.workProcess = process + '%'
      //  返回顶部
      var timer = setInterval(function () {
        let osTop = document.documentElement.scrollTop || document.body.scrollTop
        let ispeed = Math.floor(-osTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed
        this.isTop = true
        if (osTop === 0) {
          clearInterval(timer)
        }
      }, 10)
    },
    //  删除工作记录
    deleteReport(id) {
      //  请求
      this.$post(api.tool.deleteWorkRecord, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        record_id: id
      }).then((res) => {
        if (res.code === 200) {
          this.getUserWorkReport(this.curUserId)
          this.$message.success('删除成功')
        }
      })
    },
    //  确认删除工作记录
    reportDeleteConfirm(id) {
      this.deleteReport(id)
    },
    //  取消删除工作记录
    reportDeleteCancel() {
      this.$message.error('删除失败')
    },
    // 发送邮件
    sendEmail(email) {
      this.$post(api.tool.sendEmailByGroup, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        group_email: email,
        send_date: this.reportDate,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('发送成功')
        }
      })
    },
    //  回到自己页面
    backToReport() {
      this.$router.push({ path: '/snippets' })
      this.reload()
    },
    // 通过链接跳转
    urlNamePathLink(username) {
      this.$router.push({ path: '/snippets/' + username })
    },
    urlNamePathLinkClose(username) {
      this.$router.push({ path: '/snippets/' + username })
      this.closeChange(true)
    },
    urlGroupPathLinkClose(group) {
      this.$router.push({ path: '/snippets/group' + group })
    },
    // 关闭侧边栏
    closeChange(value) {
      if (value) {
        this.onOpenChange(['-1'])
      }
      this.indexMark = -2
      const iconIndexArr = [0, 1, 2, 3, 4, 5, 6]
      this.$refs.myIcon.style.display = 'inherit'
      this.$refs.myIconBlue.style.display = 'none'
      iconIndexArr.forEach(item => {
        try {
          if (this.$refs.teamIcon[item] !== 'undefined') {
            this.$refs.teamIcon[item].style.display = 'inherit'
          }
        } catch (error) {
          return
        }

        if (this.$refs.teamIconBlue[item] !== 'undefined') {
          this.$refs.teamIconBlue[item].style.display = 'none'
        }
      })

    }
  },
  created() {
    if (localStorage.impr_id && localStorage.impr_token) {
      this.avatar = localStorage.impr_picture
      this.curUserId = localStorage.impr_id
      this.searchUserId = localStorage.impr_id

      this.processInit()
      this.dateInit()
      this.getGroupList()
      this.getUserList()
    } else {
      this.$router.push({ path: '/login' })
    }
  },
}
</script>

<style scoped>
/* Common */
#components-layout-demo-basic a-select {
  background: #1a73e8;
}

#components-layout-demo-basic .ant-layout {
  background: #fff;
}

#components-layout-demo-basic .ant-layout-header,
#components-layout-demo-basic .ant-layout-footer {
  height: 55px;
  padding: 0;
  background: #fff;
  color: #000;
}

#components-layout-demo-basic .ant-layout-content {
  background: #fff;
  color: #fff;
  min-height: 1145px;
}

.container {
  /*width: 60%;*/
  width: 1120px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  color: #000;
}

.clearfix {
  content: '';
  display: block;
  clear: both;
}

/* 日期选择 */
#components-layout-demo-basic>>>.ant-calendar-picker-input.ant-input {
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  color: #333333;
  background-color: #ffffff;
  cursor: pointer;
}

#components-layout-demo-basic>>>.ant-calendar-range-picker-separator {
  margin-top: 4px;
}

#components-layout-demo-basic>>>.ant-calendar-range-picker-input {
  cursor: pointer;
}

/* Logo */
.logo span {
  line-height: 38px;
  margin-left: 10px;
  vertical-align: top;
  font-family: GoogleSans-Medium;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  color: #1a73e8;
}

#components-layout-demo-basic>>>.ant-input {
  height: 40px;
  border-radius: 8px;
  background-color: #f1f3f4;
  font-size: 14px;
  border: none;
}

#components-layout-demo-basic>>>.ant-input::placeholder {
  font-size: 14px;
  color: #bbbbbb;
}

#components-layout-demo-basic>>>.certain-category-icon {
  font-size: 21px;
  color: #555555;
}

/* report */
.report {
  min-height: 1091px;
  width: 100%;
  margin-top: 40px;
  display: flex;
  z-index: 99;
}

.report-menu {
  width: 320px;
  display: flex;
  flex-direction: column;
}

/* avatar name */
.info-prof {
  height: 81px;
}

.info-prof-avatar {
  margin-top: 5px;
  margin-left: 4px;
  width: 72px;
  height: 72px;
}

.info-prof-avatar img {
  height: 100%;
  width: 100%;
  border-radius: 50%;

}

.info-prof-name {
  height: 16px;
  font-family: GoogleSans-Medium;
  font-size: 20px;
  line-height: 19px;
  color: #222222;
  margin-top: 23px;
}

.info-prof-offer {
  height: 12px;
  font-family: GoogleSans-Regular;
  font-size: 14px;
  line-height: 19px;
  color: #555555;
  margin-top: 10px;
}

/* tab */
#components-layout-demo-basic>>>.ant-menu-item {
  display: flex;
  align-content: center;
  border-radius: 0 22px 22px 0;
  height: 44px;
}

#components-layout-demo-basic>>>.first-sub-menu .ant-menu-submenu-arrow::after,
#components-layout-demo-basic>>>.first-sub-menu .ant-menu-submenu-arrow::before {
  width: 0;
  height: 0;
}

#components-layout-demo-basic>>>.ant-menu-submenu-title {
  height: 44px;
  background-color: #ffffff;
  border-radius: 0 24px 24px 0;
  color: #222222;
  padding-top: 2px;

}

#components-layout-demo-basic>>>.ant-menu-submenu-open .ant-menu-submenu-title {
  height: 44px;
  background-color: #e9f0fd;
  color: #2177e9;
  border-radius: 0 24px 24px 0;
}

#components-layout-demo-basic>>>.ant-menu-item img {
  width: 24px;
  height: 24px;
  margin-top: 10px;
}

#components-layout-demo-basic>>>.ant-menu-submenu img {
  width: 24px;
  height: 24px;
}

#components-layout-demo-basic>>>.ant-menu-item span,
#components-layout-demo-basic>>>.ant-menu-submenu span.sub-menu-title {
  font-family: GoogleSans-Medium;
  font-size: 14px;
  /*color: #222222;*/
  margin-left: 18px;
}

#components-layout-demo-basic>>>.ant-menu-submenu-selected {
  color: #222222;
}

#components-layout-demo-basic>>>.ant-menu-item.ant-menu-item-selected,
#components-layout-demo-basic>>>.menu-item-user.ant-menu-item.ant-menu-item-selected {
  background-color: #ffffff;
  color: #2177e9;
}

#components-layout-demo-basic>>>.ant-calendar-picker-icon {
  display: none;
}

.ant-menu-vertical .ant-menu-item::after,
.ant-menu-vertical-left .ant-menu-item::after,
.ant-menu-vertical-right .ant-menu-item::after,
.ant-menu-inline .ant-menu-item::after {
  border: 0;
}

#components-layout-demo-basic>>>.reportDateSelect .ant-calendar-picker-input {
  height: 40px;
  border: solid 1px #e5e5e5;
  color: rgba(0, 0, 0, 0.65);
  width: 150px;
}

#components-layout-demo-basic>>>.ant-calendar-picker-input.ant-input-disabled {
  background-color: #fafafa;
  color: #bbbbbb;
}

/* timeline */
.ant-timeline {
  margin-top: 30px;
}

#components-layout-demo-basic>>>.ant-timeline-item-head {
  width: 14px;
  height: 14px;
  background-color: #bbbbbb;
  border-radius: 7px;
  border: 0;
  margin-left: 1px;
}

.timeline-item-first-wrap {
  position: relative;
  width: 792px;
  /* height: 265px; */
  background-color: #ffffff;
  border-radius: 8px;
  border: solid 2px rgba(33, 119, 233, 0.5);
  padding: 24px 25px 24px 23px;
  margin-top: 22px;
  /*margin-left: 22px;*/
}

/*#components-layout-demo-basic >>> .ant-timeline-item:first-child .ant-timeline-item-head {*/
/*  width: 16px;*/
/*  height: 16px;*/
/*  background-color: #2177e9;*/
/*  border-radius: 8px;*/
/*  margin-left: 0;*/
/*}*/
#components-layout-demo-basic>>>.ant-timeline-item-tail {
  margin-left: 3px;
}

.timeline-time {
  height: 20px;
  font-family: GoogleSans-Medium;
  font-size: 20px;
  color: #222222;
  line-height: 19px;
  letter-spacing: 0;
  margin-top: 5px;
}

.timeline-time:hover {
  color: #2177e9;
}

.first-timeline-item {
  display: flex;
}

.first-timeline-item .timeline-time {
  color: #2177e9;
}

#components-layout-demo-basic>>>.group-timeline .ant-timeline-item-tail,
#components-layout-demo-basic>>>.group-timeline .ant-timeline-item-head {
  display: none;
}

#components-layout-demo-basic>>>.process-select .ant-select-selection {
  width: 150px;
  height: 40px;
  border-radius: 8px;
  border: solid 1px #e5e5e5;
  margin-top: 12px;
}

#components-layout-demo-basic>>>.process-select .ant-select-selection__rendered {
  margin-right: 24px;
  margin-top: 4px;
}

#components-layout-demo-basic>>>.process-select .ant-select-arrow i svg {
  display: none;
}

#components-layout-demo-basic>>>.process-select .ant-select-arrow {
  /* display: none; */
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 9px solid #2177e9;
  border-radius: 3px;
}

#components-layout-demo-basic .timeline-textarea {
  width: 745px;
  height: 160px;
  background-color: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  margin-top: 12px;
  resize: none;
}

#components-layout-demo-basic .timeline-textarea::placeholder {
  color: #bbbbbb;
}

#components-layout-demo-basic .timeline-textarea-history {
  width: 754px;
  min-height: 176px;
  background-color: #ffffff;
  box-shadow: 0px 0px 15px 1px rgba(17, 17, 17, 0.06);
  border-radius: 8px;
  margin-top: 27px;
}

#components-layout-demo-basic>>>.ant-timeline-item-content {
  display: flex;
  flex-direction: column;
  margin-left: 38px;
}

#components-layout-demo-basic .timeline-submit {
  width: 150px;
  height: 40px;
  background-color: #2177e9;
  border-radius: 8px;
  font-family: GoogleSans-Medium;
  font-size: 14px;
  color: #ffffff;
  margin-top: 12px;
}

/* 编辑报告 */

.report-wrap {
  display: flex;
  align-items: center;
  min-height: 30px;
  margin-left: 32px;
  /*margin-top: 9px;*/
  border-bottom: 1px solid #f5f5f5;
  padding-top: 15px;
  padding-bottom: 15px;
}

.report-wrap:last-child {
  border-bottom: 0;
}

.record-title {
  width: 100px;
  font-family: GoogleSans-Medium;
  font-size: 14px;
  color: #555555;
}

.record-content {
  width: 460px;
  font-family: "PingFang SC";
  font-size: 14px;
  color: #333333;
}

.record-process {
  width: 38px;
  margin-left: 30px;
}

.delete-icon,
.edit-icon {
  margin-top: 3px;
  margin-left: 15px;
}

svg {
  cursor: pointer;
  z-index: 999;
}

.delete-icon:hover svg {
  fill: #2177e9;
}

.edit-icon:hover svg {
  fill: #2177e9;
}

.group-title {
  font-family: GoogleSans-Bold;
  font-size: 28px;
  color: #222222;
}

.group-title span {
  color: #2177e9;
}

.none {
  display: none;
}
</style>
<style>
.quill-editor .ql-container {
  height: calc(100% - 42px);
  font-size: 14px;
}

.quill-editor .ql-toolbar.ql-snow,
.quill-editor .ql-container.ql-snow {
  border: none;
}

.quill-editor .ql-toolbar.ql-snow {
  border-bottom: 1px solid #e5e5e5;
}

.quill-editor .ql-editor.ql-blank::before {
  color: #bbb;
}

.quill-tip {
  position: absolute;
  font-size: 12px;
  font-style: italic;
  color: #bbb;
  left: 210px;
  /* right: 38px; */
  top: 88px;
  z-index: 3;
}

.ql-tooltip.ql-editing {
  z-index: 2;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
}

.ql-snow .ql-tooltip.ql-editing {
  box-shadow: none;
}

.ql-tooltip.ql-editing input {
  border-radius: 4px;
}

.ql-editor p,
.ql-editor ul,
.ql-editor ol,
.record-content p,
.record-content ul,
.record-content ol {
  margin-bottom: 0px;
  margin-top: 0px;
}

.record-content a {
  color: #0000ee;
  text-decoration: underline;
}

.ql-editor ul,
.ql-editor ol,
.record-content ul,
.record-content ol {
  padding-left: 20px
}

.record-content ul li,
.ql-editor ul li {
  list-style-type: disc;
  padding-left: 2px
}

.record-content ol li,
.ql-editor ol li {
  list-style-type: auto;
  padding-left: 2px
}
</style>